import Icon from '@ant-design/icons';
import React from 'react';

const MeteoSvg = () => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 15l-1.5 1.5M8 15l-1.5 1.5M6.5 3.5v-2M3.5 6.5h-2M8.621 4.379l1.415-1.414M4.379 4.379L2.965 2.965M4 8.156A3 3 0 119.098 5M12 11l-2.5 2.5h3L10 16"
      stroke="currentColor"
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.5 12.965a4 4 0 10-5.925-4.213A2.497 2.497 0 107.5 13.5"
      stroke="currentColor"
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.5 9.5a3.996 3.996 0 000 0 3.9 3.9 0 01.075-.748"
      stroke="currentColor"
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const MeteoIcon = (props: any) => <Icon component={MeteoSvg} {...props} />;

export default MeteoIcon;
